module.exports = __webpack_public_path__ + "img/mac.5360f8dd.png";